import { FormItemTypes } from '@bimser/core';
import { GetIconComponent } from '@bimser/icons';
import IconDataSynchronizer from '@bimser/icons/16/data-synchronizer';
import IconEvents from '@bimser/icons/16/events';
import IconSubMenu from '@bimser/icons/16/sub-menu';
import classNames from 'classnames/bind';
import React, { JSX } from 'react';
import BCScrollbars from '../../../BCScrollbars';
import { LayoutStructureItem } from '../../common/entities';
import Styles from './assets/styles.scss';
import { IBottomDockProps } from './entities';

const cx = classNames.bind(Styles);

const BottomDock = React.memo(
	({ items, selectedItems, onItemSelectionChanged }: IBottomDockProps) => {
		if (!items?.count()) {
			return null;
		}

		const onClickBottomDock = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
			e.stopPropagation();

		const getControlsIcon = (controlType: FormItemTypes.EGhostItemTypes) => {
			switch (controlType) {
				case FormItemTypes.EGhostItemTypes.ContextMenu:
					return IconSubMenu.info;
				case FormItemTypes.EGhostItemTypes.DataSynchronizer:
					return IconDataSynchronizer.info;
				default:
					return IconEvents.info;
			}
		};

		const renderControl = (control: LayoutStructureItem): JSX.Element => {
			const itemClassNames: string = cx({
				itemContainer: true,
				selected: selectedItems.includes(control.id)
			});

			return (
				<div
					className={itemClassNames}
					key={control.id}
					onClick={e => {
						onItemSelectionChanged?.(e, control);
						e.stopPropagation();
						e.preventDefault();
					}}
				>
					{GetIconComponent(
						FormItemTypes.EGhostItemTypes[control.type] &&
							getControlsIcon(control.type as FormItemTypes.EGhostItemTypes)
					)}
					{control.id}
				</div>
			);
		};

		const renderItems = (): JSX.Element[] => items.map(renderControl).valueSeq().toArray();

		return (
			<div
				className={Styles.bottomDock}
				onContextMenu={onClickBottomDock}
				onClick={onClickBottomDock}
			>
				<div className={Styles.formUnparentedItems}>
					<BCScrollbars>
						<div className={Styles.horizontalContainer}>{renderItems()}</div>
					</BCScrollbars>
				</div>
			</div>
		);
	}
);

export { BottomDock };
